import { render, staticRenderFns } from "./CoordinatorTrainers.vue?vue&type=template&id=385cfbac&scoped=true&"
import script from "./CoordinatorTrainers.vue?vue&type=script&lang=js&"
export * from "./CoordinatorTrainers.vue?vue&type=script&lang=js&"
import style0 from "./CoordinatorTrainers.vue?vue&type=style&index=0&id=385cfbac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "385cfbac",
  null
  
)

export default component.exports